var _g, _path, _path2, _circle, _path3, _path4, _circle2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 96,
    viewBox: "0 0 118 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6860_62501)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    rx: 48,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 15.5,
    r: 4.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 11,
    width: 48,
    height: 4,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 16,
    width: 31,
    height: 4,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 34.5,
    r: 4.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 30,
    width: 60,
    height: 4,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 35,
    width: 31,
    height: 4,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 53.5,
    r: 4.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 49,
    width: 63,
    height: 4,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 54,
    width: 31,
    height: 4,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 72.5,
    r: 4.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 68,
    width: 48,
    height: 4,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 73,
    width: 31,
    height: 4,
    rx: 2,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.7607 44.4043L60.073 47.1706L52.5 45.3839L53.1877 42.6176L60.7607 44.4043ZM117.607 44.737L109.874 45.673L109.514 42.8483L117.246 41.9114L117.607 44.737ZM64.2342 39.1062L62.3386 41.2729L56.4092 36.3473L58.3039 34.1816L64.2342 39.1062ZM114.675 35.3632L108.21 39.5992L106.579 37.2361L113.045 33L114.675 35.3632Z",
    fill: "#44C1C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0963 72.1839C46.2685 70.4042 48.3026 69.4784 49.7578 70.5173L54.0248 73.5637C55.48 74.6027 55.2648 76.8273 53.6375 77.568L48.8656 79.74C47.2382 80.4807 45.4192 79.182 45.5914 77.4023L46.0963 72.1839Z",
    fill: "#9B9B9B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 64,
    r: 19,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104 58C102.5 78.5 87 70.5 83 81C83 81 91.0882 86.5 100.5 76.5C109.912 66.5 104 58 104 58Z",
    fill: "#44C1C2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.385 86.6428L104.156 77.4145C111.888 67.6875 110.392 53.4709 100.665 45.7392C90.9375 38.0074 76.7209 39.7533 68.9892 49.2309C61.2574 58.958 63.0033 73.1745 72.4809 80.9063C80.7115 87.391 92.4339 87.391 100.665 80.9063L109.893 90.1346C110.89 91.1322 112.387 91.1322 113.385 90.1346C114.382 89.1369 114.382 87.6404 113.385 86.6428ZM86.6974 80.9063C76.9704 80.9063 69.2386 73.1745 69.2386 63.4474C69.2386 53.7204 76.9704 45.9886 86.6974 45.9886C96.4245 45.9886 104.156 53.7204 104.156 63.4474C104.156 73.1745 96.4245 80.9063 86.6974 80.9063Z",
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.5,
    cy: 27.5,
    r: 3.5,
    fill: "#9B9B9B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6860_62501"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    rx: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyIcon);
export default __webpack_public_path__ + "static/media/empty-icon.f78f3e5c030c8a7271748f49ebef8df6.svg";
export { ForwardRef as ReactComponent };